import { API_ENDPOINTS } from '../constants/apiEndpoints';
import apiClient from './apiClient';

import { financeService } from './financeService';

import { leaveService } from './leaveService';

const getAll = async () => (await apiClient.get(API_ENDPOINTS.users.list)).data;
const getByOrg = async (orgId) => (await apiClient.get(API_ENDPOINTS.users.usersByOrg(orgId))).data;
const getById = async (id) => (await apiClient.get(API_ENDPOINTS.users.details(id))).data;
const update = async (id, payload) => (await apiClient.put(API_ENDPOINTS.users.details(id), payload)).data;
const remove = async (id) => apiClient.delete(API_ENDPOINTS.users.details(id));

const getLeaves = async (id, options = {}) => {
  const orgId = options?.orgId || 1;
  try {
    return await leaveService.getAppliedLeaves(orgId, id, options);
  } catch (err) {
    return (await apiClient.get(API_ENDPOINTS.users.leaves(id))).data;
  }
};

const getLeave = async (id, leaveId) => (await apiClient.get(API_ENDPOINTS.users.leaveDetails(id, leaveId))).data;

const createLeave = async (id, payload, orgId = 1) => {
  if (payload.startDate || payload.from_date) {
    return leaveService.applyLeave(orgId, id, payload);
  }
  return (await apiClient.post(API_ENDPOINTS.users.leaves(id), payload)).data;
};

const updateLeave = async (id, leaveId, payload) =>
  (await apiClient.put(API_ENDPOINTS.users.leaveDetails(id, leaveId), payload)).data;

const cancelLeave = async (id, leaveId) =>
  (await apiClient.patch(API_ENDPOINTS.users.cancelLeave(id, leaveId))).data;

const getCompensations = async (id, orgId) =>
  (await apiClient.get(API_ENDPOINTS.users.compensations(id), { params: orgId ? { orgId } : undefined })).data;
const saveCompensations = async (id, payload) =>
  (await apiClient.post(API_ENDPOINTS.users.compensations(id), payload)).data;

const getSalary = async (id, options = {}) => financeService.getUserSalary(id, options);

const saveSalary = async (id, payload) => financeService.saveUserSalary(id, payload);


export const userService = {
  getAll,
  getByOrg,
  getById,
  update,
  remove,
  getLeaves,
  getLeave,
  createLeave,
  updateLeave,
  cancelLeave,
  getLeaveTypes: leaveService.getLeaveTypes,
  createLeaveType: leaveService.createLeaveType,
  getOrgLeaveCount: leaveService.getOrgLeaveCount,
  setOrgLeaveCount: leaveService.setOrgLeaveCount,
  getEmployeeLeaveCount: leaveService.getEmployeeLeaveCount,
  setEmployeeLeaveCount: leaveService.setEmployeeLeaveCount,
  getEmployeeAllLeaveCounts: leaveService.getEmployeeAllLeaveCounts,
  applyLeave: leaveService.applyLeave,
  getAppliedLeaves: leaveService.getAppliedLeaves,
  getCompensations,
  saveCompensations,
  getSalary,
  saveSalary,
};

